import { useEffect, useRef } from "react";
import { handleEvent } from "../../util/user-events";

interface LayoutTrackerProps {
    layout: "new" | "legacy";
}

export const LayoutTracker: React.FC<LayoutTrackerProps> = ({ layout }) => {
    const hasTracked = useRef(false);

    useEffect(() => {
        if (!hasTracked.current) {
            hasTracked.current = true;
            handleEvent("user-layout-rendered", { layout });
        }
    }, [layout]);

    return null;
};
